import React from 'react';
import companyLogo from '../../Assets/ems logo.png';
import companyLogo2 from '../../Assets/raklogo2.png';

const AppointmentTemplate = ({
    tenantName,
    companyAddress,
    companyContact,
    currentdate,
    employeeName,
    employeeAddress,
    offerDate,
    designation,
    joiningDate,
    restrictionPeriod,
    ManagerName,
    salaryComponents,
    totalCTC,
}) => {
    const formatAddress = (addr) => {
        if (!addr) return "Address not available";
        return [
            addr.landMark,
            addr.streetLine1,
            addr.streetLine2,
            addr.city,
            addr.state,
            addr.postalCode,
            addr.country,
        ]
            .filter(Boolean)
            .join(", ");
    };

    const designationText =
        designation?.designation || designation?.name || designation || "";

    return `
    <div style="
      font-family: Arial, Helvetica, sans-serif;
      font-size: 14px;
      color: #000;
      line-height: 1.6;
      padding: 30px 40px;
      background: #fff;
      box-sizing: border-box;
      width: 100%;
    ">

      <!-- ================= LOGO HEADER ================= -->
     <div style="
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
">
    <div>
        <img
            src="${companyLogo}"
            alt="Company Logo"
            style="height: 80px; width: auto; max-width: 280px; object-fit: contain;"
        />
    </div>

    <div>
        <img
            src="${companyLogo2}"
            alt="RAK Softech Private Limited"
            style="height: 50px; width: auto; max-width: 280px; object-fit: contain;"
        />
    </div>
</div>

      <hr style="border: 0; border-top: 1px solid #000; margin: 10px 0 20px 0;" />

      <!-- ================= DATE ================= -->
      <p style="text-align: right; margin: 0 0 20px 0;">
        <strong>Date:</strong> ${currentdate}
      </p>

      <!-- ================= RECIPIENT ================= -->
      <p style="margin: 0 0 20px 0;">
        To,<br />
        ${employeeName}<br />
        Address: ${formatAddress(employeeAddress)}
      </p>

      <!-- ================= TITLE ================= -->
      <h3 style="
        text-align: center;
        margin: 40px 0 25px 0;
        font-size: 18px;
        font-weight: bold;
        text-decoration: underline;
      ">
        LETTER OF APPOINTMENT
      </h3>

      <p>Dear <strong>${employeeName}</strong>,</p>

      <p style="text-align: justify;">
        With reference to our discussion and letter of offer dated
        <strong>${offerDate}</strong>, we are pleased to appoint you as
        <strong>${designationText}</strong> w.e.f.
        <strong>${joiningDate ? new Date(joiningDate).toLocaleDateString() : "TBD"}</strong>
        subject to the following terms and conditions. The remuneration details
        are enclosed herewith as <strong>Annexure – A</strong>.
      </p>

      <h3 style="
        margin: 30px 0 15px 0;
        font-size: 16px;
        font-weight: bold;
      ">
        TERMS &amp; CONDITIONS
      </h3>

      <ol style="padding-left: 22px; margin: 0 0 20px 0; text-align: justify;">
        <li style="margin-bottom: 10px;">
          (a) For new joined employee probation period is of Three Months from the date of joining. Employee will be deemed to be on probation until he is informed in writing that he is confirmed in the services of Company by appropriate authority. Either party can terminate employment by giving one month’s notice in writing during the period of probation without assigning any reason.
          <br /><br />
          (b) In case employee leave the company before completion of one-year services with the company, employee will have to refund all joining expenses if any reimbursed to you at the time of joining viz. expenses on transportation of household goods, travel of self &amp; family and notice pay paid to your last employer by RAK Softech Private Limited.
        </li>

        <li style="margin-bottom: 10px;">
          After confirmation in the employment of the Company, either party can terminate employment by giving Three months notice in writing or salary in lieu thereof, however the decision regarding earlier release and / or salary in lieu of notice, shall be at the discretion of the Management.
        </li>

        <li style="margin-bottom: 10px;">
          Your services can be terminated, without any notice or pay in lieu thereof, in case of loss of confidence or any violation of code of conduct.
        </li>

        <li style="margin-bottom: 10px;">
          <strong>Appraisal Policy</strong>
          <ol type="a" style="padding-left: 20px; margin-top: 6px;">
            <li>There will be no appraisal during the first two years of your employment.</li>
            <li>Future appraisals, if any, will depend on company policy, business performance, and your individual performance.</li>
          </ol>
        </li>

        <li style="margin-bottom: 10px;">
          You will be eligible to the benefits of the Company’s Leave Rules.
        </li>

        <li style="margin-bottom: 10px;">
          <strong>Leave:</strong>
          <ol type="a" style="padding-left: 20px; margin-top: 6px;">
            <li>You will be entitled to leave as per the company’s leave policy, which may include casual leave, sick leave, and earned leave.</li>
            <li>Leaves cannot be carried forward to the next year under any circumstances.</li>
          </ol>
        </li>

        <li style="margin-bottom: 10px;">You will report to undersigned or any other officer designated.</li>

        <li style="margin-bottom: 10px;">
          Further by virtue of accepting the terms and conditions of employment, you undertake willingly to co-operate, participate, and directly contribute
        </li>

        <li style="margin-bottom: 10px;">
          Whatever required in the constant efforts of the company to economize and optimize the operations and wherever required shall undertake to retrain and reorient yourself to meet the specific needs of the time and situation in the business operations of the company.
        </li>

        <li style="margin-bottom: 10px;">
          You may be called upon to perform such other duties or take on such other responsibilities in the interest of the company’s business and priorities, which the management believes are well within your capabilities and of which the management will be the sole judge. In this regard, it is further clarified that with ever changing scene of technology, office automation, administrative procedure, you will adapt new methods of working with the use of modern or modified equipment, tools etc. of work as expected by the circumstances of the company’s business in a competitive environment.
        </li>

        <li style="margin-bottom: 10px;">
          At any time, during your service with the company, you are liable to be transferred from one section / department / site to another and / or from one establishment / unit / site of the company to another located anywhere in India or abroad, including company’s partly or fully owned or promoted establishment / unit. In the event of such transfer, you shall be governed by and shall be subject to the rules and regulations of the establishment / unit you are posted at.
        </li>

        <li style="margin-bottom: 10px;">
          You are required to keep us informed of any changes in your residential address, family and / or civil status. Any intimation, notice or communication sent at the said address through U.P.C. shall be considered as sufficient proof of service / delivery.
        </li>

        <li style="margin-bottom: 10px;">
          You shall be governed by and shall be subject to the Code of Conduct, Service Rules and such other rules, regulations, and policies applicable to your category of employment and as prevailing at the time of your joining or as subsequently modified or amended or replaced and in force from time to time.
        </li>

        <li style="margin-bottom: 10px;">
          You shall not, during continuance of your employment, undertake or carry on or be connected in any manner whether directly or indirectly through any of your relations or associations, any other business, trade, or profession whatsoever without prior express permission in writing of the company. You shall devote your whole time and attention to your duties with the company.
        </li>

        <li style="margin-bottom: 10px;">
          You shall not, during the continuance of your employment and thereafter, disclose and divulge to any person, firm, or body whatsoever, any information of any description acquired by you while in the services of the Company, concerning the business, manufacturing process, commercial practice of the company or any of its associates, including customers and suppliers.
        </li>

        <li style="margin-bottom: 10px;">
          You shall not contest, participate, or hold a political appointment without prior consent of the Management.
        </li>

        <li style="margin-bottom: 10px;">
          During the continuance of your employment with the company and thereafter, any process, practice, discovery, or invention developed or acquired by you while discharging of the assigned duties, shall remain the sole property of the company and same shall not be used in any manner whatsoever by you without our specific knowledge and express permission.
        </li>

        <li style="margin-bottom: 10px;">
          <strong>Restriction on Employment with Clients</strong>
          <br />
          You shall not accept employment, directly or indirectly, with any of our clients or associated organizations during your employment and for a period of ${restrictionPeriod?.restrictionPeriod || "____"} months after separation, without prior written consent from the company.
        </li>

        <li style="margin-bottom: 10px;">
          Your appointment and continuance of your employment with the Company is subject to you being declared medically fit to carry out the jobs assigned to you, by the medical Officer of the Company or Medical practitioner nominated by the company from time to time.
        </li>

        <li style="margin-bottom: 10px;">
          In case for what–so–ever reason, you relinquish from the services of the company, you will not join services or not work in any capacity with any competitor, for period of next three years from the date of separation from the Company. In case of contravention of this clause, the Management shall reserve the right to proceed with legal action deemed appropriate against you.
        </li>

        <li style="margin-bottom: 10px;">
          The age of retirement or superannuation shall be 58 (fifty-eight) years.
        </li>

        <li style="margin-bottom: 10px;">
          <strong>Notice Period</strong>
          <ol type="a" style="padding-left: 20px; margin-top: 6px;">
            <li>Your notice period will be 60 days (2 months).</li>
            <li>However, the company reserves the right to release you earlier, subject to management’s discretion and replacement availability.</li>
          </ol>
        </li>

        <li style="margin-bottom: 10px;">
          In case you request release before completing the full notice period, you may be allowed an early exit by paying a buyout amount equivalent to the remaining notice period salary, subject to management approval.
        </li>
      </ol>

      <!-- ================= SIGNATURE ================= -->
      <h3 style="margin: 30px 0 10px 0; font-size: 16px; font-weight: bold;">
        SIGNATURE
      </h3>

      <p style="margin: 0 0 10px 0;">Yours faithfully,</p>

      <p style="margin: 0 0 20px 0;">
        For <strong>${tenantName}</strong><br />
        ${ManagerName}<br />
        Authorised Signatory
      </p>

      <hr style="border: 0; border-top: 1px solid #000; margin: 20px 0;" />

      <!-- ================= ACCEPTANCE ================= -->
      <h3 style="margin: 0 0 10px 0; font-size: 16px; font-weight: bold;">
        ACCEPTANCE
      </h3>

      <p style="margin: 0 0 10px 0;">
        I have carefully read and fully understood the terms and conditions of my
        employment and hereby accept the same.
      </p>

      <p style="margin: 0 0 20px 0;">
        <strong>Name:</strong> ${employeeName}<br />
        <strong>Signature:</strong> ____________________<br />
        <strong>Date:</strong> ____________________
      </p>

     <!-- ================= ANNEXURE ================= -->
<div style="page-break-before: always; break-before: page;">

  <h3 style="
    text-align: center;
    margin: 40px 0 15px 0;
    font-size: 16px;
    font-weight: bold;
    text-decoration: underline;
  ">
    ANNEXURE – A
  </h3>

  <p style="margin: 0 0 15px 0;">
    <strong>Name:</strong> ${employeeName}<br />
    <strong>Designation:</strong> ${designationText}
  </p>

  <table
    width="100%"
    cellpadding="0"
    cellspacing="0"
    style="
      border-collapse: collapse;
      font-size: 13px;
      margin-top: 10px;
      width: 100%;
      table-layout: fixed;
    "
  >
    <thead>
      <tr>
        <th style="border: 1px solid #000; text-align: left; padding: 6px 8px; width: 10%;">S. No</th>
        <th style="border: 1px solid #000; text-align: left; padding: 6px 8px; width: 40%;">Component</th>
        <th style="border: 1px solid #000; text-align: left; padding: 6px 8px; width: 25%;">Amount (INR)</th>
        <th style="border: 1px solid #000; text-align: left; padding: 6px 8px; width: 25%;">Monthly</th>
      </tr>
    </thead>
    <tbody>
      ${salaryComponents
            .map(
                (row, i) => `
        <tr>
          <td style="border: 1px solid #000; padding: 6px 8px; text-align: left;">${i + 1}</td>
          <td style="border: 1px solid #000; padding: 6px 8px; text-align: left;">${row.name}</td>
          <td style="border: 1px solid #000; padding: 6px 8px; text-align: left;">${Number(row.annual).toLocaleString("en-IN")}</td>
          <td style="border: 1px solid #000; padding: 6px 8px; text-align: left;">${Number(row.monthly).toLocaleString("en-IN")}</td>
        </tr>
      `
            )
            .join("")}
    </tbody>
  </table>

  <p style="margin-top: 10px; font-size: 12px;">
    * As per company CTC policy.
  </p>

</div>
    </div>
  `;
};

export default AppointmentTemplate;